import axios from 'axios'

const dbUsr = localStorage.getItem('db_usr')
const parsedDbUsr = dbUsr ? JSON.parse(dbUsr) : null
const authToken = parsedDbUsr?.token

if (authToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
}
